export const CountryListConstants = {
    GET_COUNTRY_LIST: 'GET_COUNTRY_LIST',

    GETALL_COUNTRIES_REQUEST: 'GETALL_COUNTRIES_REQUEST',
    GETALL_COUNTRIES_SUCCESS: 'GETALL_COUNTRIES_SUCCESS',
    GETALL_COUNTRIES_FAILURE: 'GETALL_COUNTRIES_FAILURE'
};
